var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusFailed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#FCE5EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#FCE5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20798 8.20076C8.65189 7.76635 9.37169 7.76648 9.81569 8.20076L18.2185 16.4258L26.1839 8.6298C26.6279 8.19535 27.3476 8.19549 27.7916 8.6298C28.2356 9.06439 28.2356 9.76908 27.7916 10.2037L19.827 17.9997L27.7924 25.7964L27.8699 25.8808C28.2339 26.3179 28.2086 26.963 27.7924 27.3703C27.3763 27.7776 26.7175 27.8027 26.271 27.4466L26.1839 27.3703L18.2185 19.5736L9.81569 27.7994L9.72938 27.8756C9.28289 28.2318 8.62414 28.2065 8.20798 27.7994C7.79182 27.392 7.76577 26.7469 8.12971 26.3098L8.20798 26.2255L16.6108 17.9997L8.20798 9.77463C7.76414 9.34003 7.76403 8.6353 8.20798 8.20076Z",
    fill: "#E00034"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFailed);
export default __webpack_public_path__ + "static/media/status_failed.76ee7c821b9e9382298a9d365676c26d.svg";
export { ForwardRef as ReactComponent };